export default {
  title: 'C нами путешествуют миллионы',
  // Цифры (12 лет, 5 млн человек, 500 000 отзывов) — маркетинговые метрики, обновляются вручную.
  subtitle: 'За 12 лет экскурсии Трипстера посетили 5 млн человек и оставили 500 000 отзывов',
} as const;
